

























import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
@Component({
  name: "OrderComplete",
})
export default class OrderComplete extends Vue {
  @Prop({ default: "2022-02-01 10:00" })
  expiredTime: string;
}
